import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { TranslationService } from '../../core/translation.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {


  @Input() currentSearchItem: {itemKey: string, itemValue: string, placeHolder: string, searchTextValue: string, focus: boolean};

  @Input() currentInnerSearchItem: {itemKey: { eclEBS: string[], nlcSAP: string[] }, itemValue: string};

  @Input() dropdownItems: {itemKey: string, itemValue: string, placeHolder: string, focus: boolean,
    innerSearch: {itemKey: { eclEBS: string[], nlcSAP: string[] }, itemValue: string, itemCode: string}[]}[];

  @Output() searchContext: EventEmitter<{itemKey: string, searchValue: {textValue: string, innerSearch: {itemKey: { eclEBS: string[], nlcSAP: string[] }, itemValue: string}}}> =
    new EventEmitter<{itemKey: string, searchValue: {textValue: string, innerSearch: {itemKey: { eclEBS: string[], nlcSAP: string[] }, itemValue: string}}}>();

  searchTextValue = '';
  isOpen = false;


  
  constructor(private translationService: TranslationService,private elementRef: ElementRef) { }

  

  ngOnInit() {
    this.searchTextValue = this.currentSearchItem.searchTextValue;
  }

  onInnerSearchChange(item: {itemKey: { eclEBS: string[], nlcSAP: string[] }, itemValue: string, itemCode: string}) {
    this.currentInnerSearchItem = item;
    if (this.searchTextValue) {
      this.searchContext.emit({itemKey: this.currentSearchItem.itemKey, searchValue: {textValue: this.searchTextValue.trim(), innerSearch: item}});
    }
    var dropdownMenu = document.querySelector('.dropdown-menu');
    dropdownMenu?.classList.remove('show');
    this. isOpen = false;
  }
  
  onSearchValueChange() {
    this.searchContext.emit({itemKey: this.currentSearchItem.itemKey, searchValue: {textValue: this.searchTextValue.trim(), innerSearch: this.currentInnerSearchItem}});
  }
  eventHandler() {
    if (this.searchTextValue.length >= 6 ) {
      this.searchContext.emit({itemKey: this.currentSearchItem.itemKey, searchValue: {textValue: this.searchTextValue.trim(), innerSearch: this.currentInnerSearchItem}});
    }
 } 

 toggleData()
 {
  var dropdownMenu = document.querySelector('.dropdown-menu');
  if(this. isOpen == false)
  {
    dropdownMenu?.classList.add('show');
    this. isOpen = true;
  }
  else
  {
    dropdownMenu?.classList.remove('show');
    this. isOpen = false;
  }
 }

 @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      var dropdownMenu = document.querySelector('.dropdown-menu');
      dropdownMenu?.classList.remove('show');
      this. isOpen = false;
    }

  }

  focusIn()
  {
    if(this. isOpen == true)
    {
      var dropdownMenu = document.querySelector('.dropdown-menu');
      dropdownMenu?.classList.remove('show');
      this. isOpen = false;
    }
  }
}
